import React, { useRef, useState } from 'react';
// https://github.com/JustFly1984/react-google-maps-api
// https://react-google-maps-api-docs.netlify.app/
import { Autocomplete, LoadScript } from "@react-google-maps/api";

/*
 * https://developers.google.com/maps/documentation/places/web-service/autocomplete#maps_http_places_autocomplete_amoeba_strict-js
 */
function PlaceComponent(props) {
  const inputRef = useRef();
  const [ libraries ] = useState(['places']);

  let ip_based_location = '';
  if (props.placeholder && props.placeholder.city && props.placeholder.state) {
    ip_based_location = props.placeholder.city + ', ' + props.placeholder.state;
  }

  // https://developers.google.com/maps/documentation/javascript/place-autocomplete
  // https://developers.google.com/maps/documentation/javascript/supported_types
  const options = {
    componentRestrictions: { country: "us" },
    fields: ['address_components', 'formatted_address', 'geometry.location'],
    // types: ['(regions)'],  // to lock it to City/Town only (this isn't a great UX)
  };

  return (
    <LoadScript
      googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
      libraries={libraries}
      preventGoogleFontsLoading
    >
      <Autocomplete
        onLoad={ref => inputRef.current = ref}
        onPlaceChanged={() => props.handlePlaceChanged(inputRef.current)}
        options={options}
      >
        <input
          type="text"
          className="form-control"
          placeholder="Enter Location"
          defaultValue={ip_based_location}
        />
      </Autocomplete>
    </LoadScript>
  );
}

export default PlaceComponent;
